import client from "./client";

export default {
    async getTenantsByCounty() {
        return client.parseResponse(await client.get('/tenants-by-county-report'))
    },
    async getTenantsByDay() {
        return client.parseResponse(await client.get('/tenants-by-day-report'))
    },
    async getTenantDashboardSummary(data) {
        return client.parseResponse(await client.get('/tenant-dashboard-summary', data))
    },
    async getTenantSummary() {
        return client.parseResponse(await client.get('/tenant-summary'))
    },
    async getTenantProfileCompleteness(tenant) {
        if (tenant == null) {
            return client.parseResponse(await client.get('/profile-completeness'))
        }
        return client.parseResponse(await client.get('/profile-completeness/' + tenant.id))
    },
    async getTenantDocuments() {
        return client.parseResponse(await client.get('/tenant-documents'));
    },
    async getUserTenant() {
        return client.parseResponse(await client.get('/user-tenant'));
    },

    async getTenants(filters) {
        return client.parseResponse(await client.get('/tenants', filters));
    },
    async getTenant(id) {
        return client.parseResponse(await client.get('/tenants/' + id));
    },
    async createTenant(data) {
        return client.parseResponse(await client.post('/tenants', data))
    },
    async editTenant(data) {
        return client.parseResponse(await client.post('/tenants/' + data.get('id') + "?_method=PUT", data, {
            'Content-Type': 'multipart/form-data'
        }))
    },
    async resetPasswordFromAdmin(tenant) {
        return client.parseResponse(await client.post('/admin/reset-tenant-password/' + tenant.id, tenant))
    },

    async deleteDocument(data) {
        return client.parseResponse(await client.delete('/tenant-documents/' + data.id))
    },

    async getTenantTpsDashboardSummary() {
        return client.parseResponse(await client.get('/tenant-tps-dashboard'))
    },
    async getTenantTenancies() {
        return client.parseResponse(await client.get('/tenant-tenancies'))
    },
    async searchTenant(data) {
        return client.parseResponse(await client.get('/search-tenant', data))
    },

    async exportTenantsReport(filters) {
        return client.parseResponse(await client.get('/export-tenants', filters, {responseType: 'blob'}));
    },
}
